import { Box, Grid2 as Grid, Typography } from "@mui/material";
import { green, red } from "@mui/material/colors";
import CancelIcon from "@mui/icons-material/Cancel";
import { LoadingButton } from "@mui/lab";
import { convertObjectDateToUSString } from "../../notary/functions";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import axios from "axios";
import React, { useState } from "react";
import { useSelector } from "react-redux";

const CustomDocNocNotaryOwnerTab = ({ isReadOnlyPage = false }) => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession]?.user);
  const { selectedRow } = useSelector((state) => state.myPermitsComponent);

  const [resendLoading, setResendLoading] = useState(false);
  const { owner } = selectedRow?.processing_permit?.notarization;
  const { notarization } = selectedRow?.processing_permit;

  const handleResendInvitation = async () => {
    try {
      setResendLoading(true);

      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/notary/resend-owner-notary-invitation`,
        {
          task_id: selectedRow?.task_id,
          cst_package_id: selectedRow?.cst_packageID,
          bn_id:
            selectedRow?.processing_permit?.notarization?.owner?.notarization
              ?.bn_id,
          currentSession: currentSession,
        },
        {
          withCredentials: true,
        },
      );
    } catch (error) {
    } finally {
      setResendLoading(false);
    }
  };

  const renderLogs = () => {
    return (
      <>
        <Grid size={{ sm: 10 }}>
          <Typography variant="body2" fontWeight="bold">
            Notary Joined to the session
          </Typography>
        </Grid>
        <Grid size={{ sm: 2 }} align="right">
          {owner?.notarization?.logs?.[owner?.notarization?.attempt]
            ?.notary_joined ? (
            <CheckCircleIcon
              style={{
                color: green[500],
              }}
            />
          ) : (
            <CancelIcon style={{ color: red[500] }} />
          )}
        </Grid>
        <Grid size={{ sm: 10 }}>
          <Typography variant="body2" fontWeight="bold">
            Owner/Agent Joined to the session
          </Typography>
        </Grid>
        <Grid size={{ sm: 2 }} align="right">
          {owner?.notarization?.logs?.[owner?.notarization?.attempt]
            ?.owner_joined ? (
            <CheckCircleIcon
              style={{
                color: green[500],
              }}
            />
          ) : (
            <CancelIcon style={{ color: red[500] }} />
          )}
        </Grid>
        <Grid size={{ sm: 10 }}>
          <Typography variant="body2" fontWeight="bold">
            {owner?.notarization?.logs?.[owner?.notarization?.attempt]
              ?.owner_joined
              ? owner?.notarization?.logs?.[owner?.notarization?.attempt]
                  ?.id_passed
                ? "ID Verification Passed"
                : owner?.notarization?.logs?.[owner?.notarization?.attempt]
                      ?.id_failed
                  ? "ID Verification Failed"
                  : "Waiting for ID Verification..."
              : ""}
          </Typography>
        </Grid>
        <Grid size={{ sm: 2 }} align="right">
          {owner?.notarization?.logs?.[owner?.notarization?.attempt]
            ?.id_passed ? (
            <CheckCircleIcon
              style={{
                color: green[500],
              }}
            />
          ) : owner?.notarization?.logs?.[owner?.notarization?.attempt]
              ?.id_failed ? (
            <CancelIcon style={{ color: red[500] }} />
          ) : (
            <></>
          )}
        </Grid>
        {owner?.notarization?.logs?.[owner?.notarization?.attempt]
          ?.owner_joined &&
          owner?.notarization?.logs?.[owner?.notarization?.attempt]
            ?.notary_joined && (
            <Grid size={{ sm: 12 }}>
              <Typography variant="body2" fontWeight="bold">
                Signing In Progress...
              </Typography>
            </Grid>
          )}
      </>
    );
  };

  return (
    <Box>
      {!owner?.notarization?.is_notarized &&
      !notarization?.finalized &&
      owner?.notarization?.notary_failed &&
      !owner?.notarization?.failed_resent ? (
        <Box>
          <Typography
            px={2}
            mt={1}
            align="center"
            variant="h6"
            fontWeight="bold"
            color="error"
          >
            Remote Online Notarization Failed
          </Typography>
          <Typography px={2} align="center" color="primary" variant="body2">
            The notary was unable to connect with the signer to complete the
            notarization of the required documents. To expedite the rescheduling
            of a new appointment, you can send a reminder email. Click the
            button below to send the invitation to the Owner or Agent.
          </Typography>
          {!isReadOnlyPage && (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <LoadingButton
                loading={resendLoading}
                onClick={handleResendInvitation}
                variant="contained"
              >
                Proceed
              </LoadingButton>
            </Box>
          )}
        </Box>
      ) : !owner?.notarization?.is_notarized && !notarization?.finalized ? (
        <Grid container spacing={0.5} px={2} mt={2}>
          <Grid size={{ lg: 10, sm: 10 }} sx={{ width: "100%" }}>
            <Typography variant="body2" fontWeight="bold">
              The invitation email has been sent
            </Typography>

            <Typography mt={-0.5} variant="body2">
              {owner?.personal?.email}
            </Typography>
            <Typography mt={-0.5} variant="body2">
              {owner?.personal?.mobile
                ?.replace(/\D/g, "")
                ?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")}
            </Typography>
          </Grid>
          <Grid size={{ lg: 2, sm: 2 }} align="right">
            <CheckCircleIcon
              style={{
                color: green[500],
              }}
            />
          </Grid>
          <Grid
            size={{ sm: owner?.notarization?.waiting_to_schedule ? 10 : 6 }}
            sx={{ width: "100%" }}
          >
            <Typography variant="body2" fontWeight="bold">
              RON Session Scheduled
            </Typography>
          </Grid>

          <Grid
            size={{ sm: owner?.notarization?.waiting_to_schedule ? 2 : 6 }}
            align="right"
          >
            {owner?.notarization?.waiting_to_schedule ? (
              <CancelIcon style={{ color: red[500] }} />
            ) : (
              <Typography variant="body2" align="right" fontWeight="bold">
                {convertObjectDateToUSString(
                  owner?.notarization?.appointments?.booked?.[0],
                  currentUser?.user?.personal?.[0]?.timezone,
                )}
              </Typography>
            )}
          </Grid>

          {!owner?.notarization?.waiting_to_schedule && renderLogs()}
        </Grid>
      ) : (
        <Typography
          px={2}
          mt={2}
          align="center"
          variant="body2"
          fontWeight="bold"
          color="primary"
        >
          All documents have been successfully notarized/signed by the
          Owner/Agent.
        </Typography>
      )}
    </Box>
  );
};

export default React.memo(CustomDocNocNotaryOwnerTab);
